<template>
  <div class="container">
    <div v-if="!isAuthLv1" class="row justify-content-center">
      <div class="col-md-12 mt-5 text-center">
        <h3>Unauthorized</h3>
        <p>You do not have permission to view this page.</p>
      </div>
    </div>
    <div v-else class="row justify-content-center">
      <div class="col-md-12">
        <h5 class="mt-3">Search Member:</h5>
        <div class="d-flex justify-content-center">
          <div class="input-group">
            <input
              @keyup="memberSearch"
              class="form-control"
              type="text"
              id="memberSearchInput"
              name="memberSearchInput"
              v-model="memberSearchInput"
              placeholder="Search member ID, name, or phone.."
              aria-label="Search member ID, name, or phone.."
            />
            <div class="input-group-append">
              <span
                class="input-group-text pl-4 pr-4"
                id="searchbtt"
                @click.prevent="memberSearch"
                ><i class="fas fa-search text-grey" aria-hidden="true"></i
              ></span>
            </div>
          </div>
        </div>
        <div class="mt-2 mb-5">
          <div v-if="latestMember">
            Last Search:
            <a
              href="#"
              @click.prevent="
                $router.push({
                  name: 'MemberHome',
                  params: { id: latestMember.id },
                })
              "
              >{{ latestMember.cardid }} - {{ latestMember.firstname }}
              {{ latestMember.lastname }}</a
            >
          </div>
        </div>
        <div v-if="!loading">
          <h5 v-if="isSearch">Search Result:</h5>
          <member-table
            v-if="isSearch"
            :memberResult="memberResult"
          ></member-table>
        </div>
        <div v-else class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <!--<test-table></test-table>-->
      </div>
    </div>
  </div>
</template>
<script>
/* import DataTable from "laravel-vue-datatable";
import Vue from "vue";
Vue.use(DataTable); */
//import memberSearch from "./memberSearch.vue";
import MemberTable from "./MemberTable.vue";
import { isAuthLv1 } from "./../js/utils/global.js";
//import TestTable from "./TestTable.vue";
export default {
  components: {
    //memberSearch,
    MemberTable,

    //TestTable,
  },
  data() {
    return {
      loading: false,
      isSearch: false,
      memberSearchInput: null,
      memberResult: null,
      latestMember: null,
      /*perPage: ["10", "25", "50"],
      columns: [
        {
          label: "ID",
          name: "id",
          filterable: true,
        },
        {
          label: "First Name",
          name: "firstname",
          filterable: true,
        },
        {
          label: "Email",
          name: "email",
          filterable: true,
        },
      ],*/
    };
  },
  computed: {
    isAuthLv1() {
      return isAuthLv1();
    },
  },
  created() {},
  mounted() {
    this.getLastSearch();
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        alert("All fields are not valid");
      } else {
        alert("Success!");
      }
    },
    reset() {
      Object.assign(this.$data, this.$options.data());
      this.$v.$reset();
    },

    async memberSearch() {
      //console.log(this.memberSearchInput);
      if (
        this.memberSearchInput == "" ||
        this.memberSearchInput == null ||
        this.memberSearchInput.length < 5 ||
        (!isNaN(this.memberSearchInput) && this.memberSearchInput.length < 10)
      ) {
        return false;
      }
      this.loading = true;
      this.isSearch = false;
      await axios
        .get("/api/members/find", {
          params: {
            keysearch: this.memberSearchInput,
          },
        })
        .then((response) => {
          this.memberResult = response.data;

          //console.log(response.data.data);
          this.loading = false;
          this.isSearch = true;
        });
    },
    getLastSearch() {
      if (localStorage.getItem("latestMember")) {
        this.latestMember = JSON.parse(localStorage.getItem("latestMember"));
      }
    },
  },
};
</script>
<style scoped>
#searchbtt {
  cursor: pointer;
}
</style>
